<template>
  <span class="date-renderer">
    <span class="date-renderer__date">
      {{ formatOrderedAtDate || " - " }}
    </span>
    <span class="date-renderer__time">
      {{ formatOrderedAtTime }}
    </span>
  </span>
</template>

<script setup lang="ts">
import moment from "moment"
import { computed } from "vue"

import i18n from "@/i18n"

type Props = {
  date: string | null
}

const props = defineProps<Props>()

const formatOrderedAtDate = computed(() => {
  if (!props.date) {
    return ""
  }

  const orderedAt = moment(props.date)
  const isCurrentDate = orderedAt.isSame(new Date(), "day")

  return isCurrentDate ? i18n.t("orders.today") : orderedAt.format("DD.MM.YYYY")
})
const formatOrderedAtTime = computed(() => {
  if (!props.date) {
    return ""
  }

  return moment(props.date).format("HH:mm")
})
</script>

<style lang="scss" scoped>
.date-renderer {
  display: inline-flex;
  flex-direction: column;

  &__time {
    color: $gray-color-7;
  }
}
</style>
